/* Cozyleigh: Judge.me's "Write a review" popup, made ours (Oct 2026).
   Judge.me draws the multi-step form as .jdgm-write-review-modal (plain DOM). This script watches for it and:
   - shows the piece's current photo on the first step: Judge.me keeps the photo it saw when it last rebuilt the widget
     (only when a review comes in), so pieces with no reviews point at photos since deleted from Shopify (404);
   - puts one word under the stars for the rating being picked ("Love it"), in place of Judge.me's Poor / Great ends;
   - first step: one line saying reviews earn Cozyleigh Points;
   - rewrites Judge.me's form words in our voice (labels, step headings, the upload prompt, the thank-you);
   - always asks for a name: the "Post review as anonymous" option is taken away (Maisy, Oct 17 2026);
   - photo/video step: says why a photo or video helps, with three Cozyleigh Points cards that light up as one is added;
   - thank-you step: the card for the points this review earns, and when they arrive.
   Points look like the Cozyleigh Points card everywhere (.cl-pcard / .cl-pmark, snippets/cl-points-card).
   Values come from Smile's earning rules (window.__clppSummary.reviews / "clpp:summary", assets/cozyleigh-points-panel.js)
   and fall back to 300 / 700 / 1,000, matching the Rewards page. Styles: assets/cozyleigh-review-form.css.
   Loaded by sections/apps.liquid next to a Judge.me review widget. Safe to run more than once. */
(function () {
  if (window.__clReviewForm) return; window.__clReviewForm = true;
  var me = document.currentScript;
  var signedIn = !!(me && me.getAttribute('data-customer'));
  var rewardsUrl = (me && me.getAttribute('data-rewards')) || '/pages/rewards';
  var image = me && me.getAttribute('data-image');
  var pts = { text: 300, photo: 700, video: 1000 };
  var videosOn = !(window.jdgmSettings && window.jdgmSettings.enable_review_videos === false);
  var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  var reached = 'text'; // the tier this review reaches, kept for the thank-you step
  var SAY = ['', 'Not for me', 'Could be better', 'It’s okay', 'Really like it', 'Love it'];
  var P = '.jdgm-write-review-modal__';
  var num = function (x) { try { return Number(x).toLocaleString('en-US'); } catch (e) { return String(x); } };
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function q(root, sel) { return root.querySelector(sel); }
  function header(page) { return q(page, P + 'page-header') || page.firstElementChild || page; }
  function top() { return videosOn ? Math.max(pts.video, pts.photo, pts.text) : Math.max(pts.photo, pts.text); }
  function card(n) {
    return '<span class="cl-pcard cl-pcard--s"><span class="cl-pcard__brand" aria-hidden="true">Cozyleigh</span>'
      + '<span class="cl-pcard__num"><b>' + num(n) + '</b> <span class="cl-pcard__unit">points</span></span></span>';
  }
  function useSummary(sm) {
    var v = sm && sm.reviews; if (!v || !v.text) return;
    pts = { text: Number(v.text) || 0, photo: Number(v.photo) || 0, video: Number(v.video) || 0 };
    document.querySelectorAll('.jdgm-write-review-modal [data-cl-rf]').forEach(function (n) { n.remove(); });
    scan();
  }
  function tiers() {
    var t = [{ k: 'text', label: 'Words', n: pts.text }, { k: 'photo', label: 'With a photo', n: pts.photo }];
    if (videosOn) t.push({ k: 'video', label: 'With a video', n: pts.video });
    return t.filter(function (x) { return x.n > 0; });
  }
  // Change Judge.me's words only when they still differ, so this never fights Judge.me's own re-renders.
  function say(node, text, attr) {
    if (!node) return;
    if (attr) { if (node.getAttribute(attr) !== text) node.setAttribute(attr, text); return; }
    if (node.textContent.trim() !== text) node.textContent = text;
  }
  function sayHtml(node, html) { if (node && node.getAttribute('data-cl-said') !== html) { node.innerHTML = html; node.setAttribute('data-cl-said', html); } }

  /* ---------- stars: one word for the rating ---------- */
  function sayStars(page) {
    var stars = q(page, P + 'stars'); if (!stars) return;
    var line = q(page, '.cl-rf-say');
    if (!line) { line = el('p', 'cl-rf-say'); line.setAttribute('aria-live', 'polite'); stars.insertAdjacentElement('afterend', line); }
    var score = Number((q(stars, 'input[name="score"]') || {}).value) || 0;
    var shown = Number(stars.getAttribute('data-cl-hover')) || score;
    say(line, SAY[shown] || '');
  }
  function onStar(e, leaving) {
    var star = e.target.closest && e.target.closest('.jdgm-write-review-modal .jdgm-star'); if (!star) return;
    var stars = star.closest(P + 'stars'); if (!stars) return;
    if (leaving) stars.removeAttribute('data-cl-hover'); else stars.setAttribute('data-cl-hover', star.getAttribute('data-alt') || '');
    soon();
  }
  document.addEventListener('mouseover', function (e) { onStar(e, false); });
  document.addEventListener('focusin', function (e) { onStar(e, false); });
  document.addEventListener('mouseout', function (e) { onStar(e, true); });
  document.addEventListener('focusout', function (e) { onStar(e, true); });
  document.addEventListener('click', function (e) { onStar(e, true); }, true);

  /* ---------- each step ---------- */
  function intro(page) {
    /* An open question, not a leading one (Judge.me's admin heading was "Did we make your space cozier?"). Reviews
       earn points, so the ask stays neutral and says every honest review counts (FTC, Nov 3 2026). */
    say(q(page, P + 'title'), 'How’s it settling in?');
    say(q(page, P + 'intro'), 'Tap a star to start. Loved or not quite, a few honest words help the next person decide.');
    sayStars(page);
    if (q(page, '[data-cl-rf="tease"]') || !top()) return;
    var t = el('p', 'cl-rf-tease', '<span class="cl-pmark" aria-hidden="true"></span><span>Up to <b>' + num(top()) + '</b> Cozyleigh Points for your review</span>');
    t.setAttribute('data-cl-rf', 'tease');
    var at = q(page, '.cl-rf-say'); if (at) at.insertAdjacentElement('afterend', t);
  }
  function details(page) {
    sayStars(page);
    say(q(page, 'textarea[name="review_body"]') && page.querySelector('label[for="' + q(page, 'textarea[name="review_body"]').id + '"]'), 'Your review');
    say(q(page, 'input[name="review_title"]') && page.querySelector('label[for="' + q(page, 'input[name="review_title"]').id + '"]'), 'A title, if you like');
  }
  function labelFor(page, input) { if (!input) return null; return (input.id && page.querySelector('label[for="' + input.id + '"]')) || (input.closest(P + 'field-group') || page).querySelector(P + 'field-label'); }
  function about(page) {
    say(q(page, P + 'title'), 'Who’s writing?');
    say(q(page, P + 'intro'), 'Your name goes on your review, so people know a real person wrote it.'
      + (signedIn ? '' : ' Use the email you order with and your points will find you.'));
    var email = q(page, 'input[name="reviewer_email"]'), name = q(page, 'input[name="reviewer_name"]');
    say(labelFor(page, email), 'Email');
    if (email) { var help = email.closest(P + 'field-group'); say(help && q(help, P + 'field-help'), 'Never shown on your review.'); }
    say(labelFor(page, name), 'Your name');
    say(name, 'First name and last initial is perfect', 'placeholder');
    // No anonymous reviews: hide the option and make sure it is off.
    page.querySelectorAll(P + 'checkbox-text').forEach(function (t) {
      if (!/anonym/i.test(t.textContent)) return;
      var box = t.closest(P + 'field-group') || t.closest('label');
      var input = box && q(box, 'input[type="checkbox"]');
      if (input && input.checked) input.click();
      if (box && !box.hidden) box.hidden = true;
    });
    page.querySelectorAll(P + 'anonymous-help').forEach(function (h) { if (!h.hidden) h.hidden = true; });
  }
  function hasMedia(modal) {
    var img = modal.querySelector(P + 'media-preview-container[data-type="image"], ' + P + 'media-preview-container img');
    var vid = modal.querySelector(P + 'media-preview-container[data-type="video"], ' + P + 'media-preview-container video');
    var yt = modal.querySelector('input[name="yt_url"], input[name*="youtube" i]');
    if (yt && /^(https?:\/\/)?(www\.|m\.)?(youtube\.com\/(watch\?v=|shorts\/|embed\/)|youtu\.be\/)[\w-]{6,}/i.test((yt.value || '').trim())) vid = true;
    return { photo: !!img, video: !!vid && videosOn };
  }
  function media(page, modal) {
    say(q(page, P + 'title'), 'Show us where it lives');
    say(q(page, P + 'intro'), videosOn
      ? 'A photo or a short video helps the next person picture it in their own space. It’s our favourite part to see, and it earns you more points.'
      : 'A photo helps the next person picture it in their own space. It’s our favourite part to see, and it earns you more points.');
    sayHtml(q(page, P + 'media-upload-prompt'), touch ? '<b>Tap to add a photo' + (videosOn ? ' or video' : '') + '</b>'
      : '<b>Choose a photo' + (videosOn ? ' or video' : '') + '</b> or drop it here');
    var yt = q(page, 'input[name="yt_url"]');
    if (yt) { say(labelFor(page, yt), 'Or a YouTube link'); say(yt, 'Paste a YouTube link', 'placeholder'); if (yt.hasAttribute('aria-label')) say(yt, 'Or a YouTube link', 'aria-label'); }

    var box = q(page, '[data-cl-rf="media"]');
    if (!box) {
      var t = tiers(); if (!t.length) return;
      box = el('div', 'cl-rf-media'); box.setAttribute('data-cl-rf', 'media');
      var ul = el('ul', 'cl-rf-tiers'); ul.style.setProperty('--n', t.length);
      t.forEach(function (x) {
        var li = el('li', 'cl-rf-tier', card(x.n) + '<span>' + x.label + '</span>');
        li.setAttribute('data-k', x.k); ul.appendChild(li);
      });
      box.appendChild(ul);
      var now = el('p', 'cl-rf-now'); now.setAttribute('aria-live', 'polite'); box.appendChild(now);
      header(page).appendChild(box);
    }
    var m = hasMedia(modal), k = m.video ? 'video' : m.photo ? 'photo' : 'text';
    var done = q(modal, P + 'section--page--thank-you.current-section');
    if (!done) reached = k;
    box.querySelectorAll('.cl-rf-tier').forEach(function (li) { li.classList.toggle('is-on', li.getAttribute('data-k') === k); });
    var line;
    if (k === 'video') line = 'Wonderful, that’s <b>' + num(pts.video) + ' points</b>.';
    else if (k === 'photo') line = 'Lovely, that’s <b>' + num(pts.photo) + ' points</b>.' + (videosOn && pts.video > pts.photo ? ' A short video makes it ' + num(pts.video) + '.' : '');
    else line = 'Your words earn <b>' + num(pts.text) + '</b>. Add a photo for <b>' + num(pts.photo) + '</b>' + (videosOn && pts.video ? ', or a video for <b>' + num(pts.video) + '</b>.' : '.');
    var p = box.querySelector('.cl-rf-now'); if (p.innerHTML !== line) p.innerHTML = line;
  }
  function thanks(page) {
    say(q(page, P + 'title'), 'Thank you, truly.');
    say(q(page, P + 'intro'), 'You just made our week. Your review will be on the site soon.');
    var intro = q(page, P + 'intro');
    if (intro && !q(page, '.cl-rf-sig')) intro.insertAdjacentElement('afterend', el('p', 'cl-rf-sig', 'Maisy, Ash &amp; Tristan'));
    var conf = q(page, P + 'text'); if (conf && /confirm/i.test(conf.textContent)) say(conf, 'One last step: tap the link we just emailed you to confirm it’s you.');
    var n = pts[reached] || pts.text; if (!n) return;
    var html = card(n) + '<span>Your <b>' + num(n) + ' Cozyleigh Points</b> arrive once your review is live, usually within a day or two.'
      + (signedIn ? '' : ' They go to the account with the email you used.') + ' <a href="' + rewardsUrl + '">How points work</a></span>';
    var box = q(page, '[data-cl-rf="thanks"]');
    if (!box) {
      box = el('div', 'cl-rf-thanks'); box.setAttribute('data-cl-rf', 'thanks');
      var nav = q(page, P + 'thank-you-nav'); // above Close, so the card is read before leaving
      if (nav) nav.parentNode.insertBefore(box, nav); else (q(page, P + 'page-header') || page).appendChild(box);
    }
    sayHtml(box, html);
  }

  /* ---------- the review list ---------- */
  var DATE = { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }; // the same day Judge.me's admin shows
  function list(w) {
    var n = Number(w.getAttribute('data-number-of-reviews')) || 0;
    w.classList.toggle('cl-few-hist', n < 5);
    w.classList.toggle('cl-few-tools', n < 10);
    if (n === 0) say(w.querySelector('.jdgm-rev-widg__summary-text'), 'Have one at home? Tell us how it\u2019s settling in. A few words is plenty, and a photo of it in your space makes our whole week.');
    w.querySelectorAll('.jdgm-rev__timestamp[datetime]').forEach(function (t) {
      var d = new Date(t.getAttribute('datetime')); if (isNaN(d)) return;
      var txt = d.toLocaleDateString('en-US', DATE); if (t.textContent !== txt) t.textContent = txt;
    });
    w.querySelectorAll('.jdgm-rev__body').forEach(function (b) {
      if (b.hasAttribute('data-cl-fold') || !b.offsetParent) return; // measure only once it is laid out
      b.setAttribute('data-cl-fold', '');
      var lh = parseFloat(getComputedStyle(b).lineHeight) || 24;
      if (b.scrollHeight <= lh * 7.5) return;
      b.classList.add('cl-folded');
      var more = el('button', 'cl-rev-more', 'Read more'); more.type = 'button'; more.setAttribute('aria-expanded', 'false');
      more.addEventListener('click', function () {
        var open = b.classList.toggle('cl-folded') === false;
        more.textContent = open ? 'Show less' : 'Read more'; more.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      b.insertAdjacentElement('afterend', more);
    });
  }

  /* "Review it" links (account, order page, Points drawer, desk inbox emails) end in #write-review: open Judge.me's
     form. Judge.me marks its widget set up (.jdgm--done-setup-widget) a little before its Write a review click works
     (the form's code loads separately), so: click, check the form really opened, and click again every 0.7 s for up to
     ~10 s. Page clicks only, no requests. Once open, the page sits at the reviews (so closing the form lands there)
     and the hash is dropped so a refresh doesn't reopen it. Started from scan(), which Judge.me's redraws trigger. */
  var wantWrite = location.hash === '#write-review', writeTries = 0, writeWait = false;
  function formOpen() { var c = document.querySelector('.jdgm-write-review-modal ' + P + 'content'); return !!(c && c.getBoundingClientRect().height > 0); }
  function openWrite() {
    if (!wantWrite || writeWait) return;
    var w = document.querySelector('#judgeme_product_reviews.jdgm--done-setup-widget, #judgeme_product_reviews .jdgm--done-setup-widget');
    var link = w && w.querySelector('.jdgm-write-rev-link');
    if (!link) return;
    if (formOpen()) {
      wantWrite = false;
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      w.scrollIntoView({ block: 'start' });
      return;
    }
    if (++writeTries > 15) { wantWrite = false; return; } // leave the page as it is; the button is still there
    writeWait = true;
    link.click();
    setTimeout(function () { writeWait = false; openWrite(); }, 700);
  }

  function scan() {
    openWrite();
    document.querySelectorAll('.jdgm-rev-widg').forEach(list);
    document.querySelectorAll('.jdgm-write-review-modal').forEach(function (modal) {
      if (image) modal.querySelectorAll(P + 'product-image img').forEach(function (img) {
        if (img.getAttribute('src') !== image) { img.setAttribute('src', image); img.removeAttribute('srcset'); }
      });
      modal.querySelectorAll(P + 'page--review-form-intro').forEach(intro);
      modal.querySelectorAll(P + 'page--review-details').forEach(details);
      modal.querySelectorAll(P + 'page--about-you').forEach(about);
      modal.querySelectorAll(P + 'page--share-media').forEach(function (p) { media(p, modal); });
      modal.querySelectorAll(P + 'page--thank-you').forEach(thanks);
    });
  }
  var queued = false;
  function soon() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; scan(); }); }
  new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  document.addEventListener('input', function (e) { if (e.target.closest && e.target.closest('.jdgm-write-review-modal')) soon(); }, true);
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.jdgm-write-review-modal')) soon(); }, true);
  useSummary(window.__clppSummary);
  document.addEventListener('clpp:summary', function (e) { useSummary(e.detail); });
  scan();
})();
